interface Props {
  title: React.ReactNode;
  cta?: React.ReactNode;
  className?: string;
  testId?: string;
}

export default function PageHeader(props: Props) {
  return (
    <div style={styles.container} className={props.className}>
      <h1 style={styles.title} data-testid={props.testId}>
        {props.title}
      </h1>
      {props.cta && <div style={styles.cta}>{props.cta}</div>}
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  container: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: "2rem",
    marginBottom: "1rem",
  },
  title: {
    fontSize: "28px",
    lineHeight: "36px",
    margin: 0,
  },
  cta: {
    display: "flex",
    alignItems: "center",
  },
};
